/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Body_Weight_NoneInputs */

const en_us2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No weight logged yet.`)
};

const pt_br2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum peso registrado ainda.`)
};

const es_419_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay peso registrado.`)
};

const pt_pt2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhum peso registado.`)
};

const fr_fr2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun poids enregistré pour l'instant.`)
};

const de_de2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Gewicht eingetragen.`)
};

const it_it2_progress_body_weight_none = /** @type {(inputs: Progress_Body_Weight_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun peso registrato.`)
};

/**
* | output |
* | --- |
* | "No weight logged yet." |
*
* @param {Progress_Body_Weight_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_none = /** @type {((inputs?: Progress_Body_Weight_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_none(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_none(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_none(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_none(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_none(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_none(inputs)
	return en_us2_progress_body_weight_none(inputs)
});
export { progress_body_weight_none as "progress.body_weight_none" }